import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import { ArrowLeft } from 'components/icons';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';
import { Category } from 'types/entity/category';

export type BreadcrumbProps = {
  Separator?: React.ReactNode;
  className?: string;
  listClassName?: string;
  backCategory?: Category;
  ref?: React.Ref<HTMLAnchorElement>;
};

const Breadcrumb = ({
  children,
  Separator,
  className = '',
  listClassName,
  backCategory,
  ref,
}: React.PropsWithChildren<BreadcrumbProps>) => {
  const [isDesktopSize] = useMediaQuery(desktop);

  const visibleChildren = React.Children.toArray(children).slice(
    backCategory ? -1 : -2,
  );

  return (
    <nav className={`relative md:mt-18 ${className}`} aria-label="Breadcrumb">
      <div className={`flex items-center gap-x-4 lg:gap-x-8 ${listClassName ?? ''}`} data-ffid="lst-breadcrumb-list">
        {backCategory && (
          <div data-ffid="lst-item-breadcrumb-back-navigation" className="inline-flex items-center">
            <Link
              key={backCategory?.categoryId}
              link={backCategory?._url}
              className="inline-flex items-center gap-2 leading-none"
              data-ffid="lnk-breadcrumb-back-link"
              aria-label={backCategory?.name ? `Back to ${backCategory.name}` : 'Back Button'}
              ref={ref}
            >
              <span className="text-14 leading-none">{backCategory?.name}</span>
            </Link>
          </div>
        )}

        {visibleChildren.map((Child, index) => (
          <React.Fragment key={`list-${Child}`}>
            {!backCategory && (
              <div data-ffid={`lst-breadcrumb-list-item-${index}`} className="inline-flex items-center leading-none">
                {Child}
              </div>
            )}

            {index < visibleChildren.length - (backCategory ? 0 : 1) && (
              <div
                data-ffid={`lst-breadcrumb-list-item-separator-${index}`}
                className="inline-flex items-center justify-center"
              >
                {Separator ? (
                  <span className="inline-flex items-center">{Separator}</span>
                ) : (
                  isDesktopSize && <ArrowLeft className="rotate-180 align-middle" dimension={16} />
                )}
              </div>
            )}

            {backCategory && (
              <div data-ffid={`lst-breadcrumb-list-item-${index}`} className="inline-flex items-center">
                {Child}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumb;

